import { defineComponent } from '~/utils/alpine_types'

export const getQuiz = defineComponent((args: { url: string; openAutomatically: boolean }) => ({
  quizAvailable: args.openAutomatically,

  async init() {
    if (args.openAutomatically) await this.openQuiz()
    document.addEventListener('enableQuiz', () => (this.quizAvailable = true))
    document.addEventListener('openQuiz', async () => await this.openQuiz())
  },

  async openQuiz() {
    const quizContainer = document.querySelector('#quiz-container')
    if (!quizContainer) return

    try {
      window.loadingSpinner(true)
      const res = await fetch(args.url)

      if (res.ok) {
        const html = await res.text()
        quizContainer.innerHTML = html

        if (!args.openAutomatically) {
          // setTimeout() is needed to make sure the test has fully rendered, otherwise it doesn't scroll all the way
          setTimeout(() => quizContainer.scrollIntoView({ behavior: 'smooth', block: 'start' }), 0)
        }
      } else {
        const message = await res.text()
        window.flash('alert', message)
      }
    } catch (error) {
      console.error(error)
      alert(window.I18n.unknown_error)
    } finally {
      window.loadingSpinner(false)
    }
  },
}))

export const quiz = defineComponent((args: { quizId: number; questionIds: number[] }) => ({
  questionIdx: 0,
  done: false,
  responses: args.questionIds.map((id) => ({ quiz_question_id: id, quiz_answer_ids: [] as number[] })),

  get quizState() {
    if (this.done) {
      return 'done'
    } else if (this.questionIdx + 1 < args.questionIds.length) {
      return 'incomplete'
    } else {
      return 'ready_to_submit'
    }
  },

  async submit() {
    const body = JSON.stringify({ quiz_result: { responses: this.responses } })
    const headers = { 'Content-Type': 'application/json' }

    try {
      window.loadingSpinner(true)
      const res = await fetch(`/student/quizzes/${args.quizId}/quiz_results`, { method: 'POST', body, headers })
      if (!res.ok) throw new Error()

      const html = await res.text()
      document.body.insertAdjacentHTML('beforeend', html)
      this.done = true
    } catch (error) {
      console.error(error)
      alert(window.I18n.unknown_error)
    } finally {
      window.loadingSpinner(false)
    }
  },

  async next() {
    switch (this.quizState) {
      case 'incomplete':
        this.questionIdx++
        break
      case 'ready_to_submit':
        await this.submit()
        break
      case 'done':
        this.$dispatch('openQuiz')
        break
    }
  },
}))
